export const CLIENT_PRICING_CATEGORY_QUERY_PARAM = 'clientPricingCategoryId';

export const getClientPricingCategoryIdFromSearch = (search = '') => {
  const value = new URLSearchParams(search).get(CLIENT_PRICING_CATEGORY_QUERY_PARAM);
  return String(value || '').trim();
};

export const buildClientPricingCategorySearch = (search = '', categoryId = '') => {
  const params = new URLSearchParams(search);
  const normalizedId = String(categoryId || '').trim();
  if (normalizedId) {
    params.set(CLIENT_PRICING_CATEGORY_QUERY_PARAM, normalizedId);
  } else {
    params.delete(CLIENT_PRICING_CATEGORY_QUERY_PARAM);
  }
  const query = params.toString();
  return query ? `?${query}` : '';
};

export const resolveClientPricingCategorySelection = ({
  categories = [],
  requestedId = '',
  currentId = '',
} = {}) => {
  const ids = new Set(
    (Array.isArray(categories) ? categories : [])
      .map((category) => String(category?.id || '').trim())
      .filter(Boolean)
  );
  const normalizedRequestedId = String(requestedId || '').trim();
  if (normalizedRequestedId && ids.has(normalizedRequestedId)) return normalizedRequestedId;
  const normalizedCurrentId = String(currentId || '').trim();
  if (!normalizedRequestedId && normalizedCurrentId && ids.has(normalizedCurrentId)) {
    return normalizedCurrentId;
  }
  return Array.from(ids)[0] || '';
};
